
import bleedingOutImg from '../assets/status/Bleeding Out.png';
import blindedImg from '../assets/status/Blinded.png';
import charmedImg from '../assets/status/Charmed.png';
import concentrationImg from '../assets/status/Concentration.png';
import deafenedImg from '../assets/status/Deafened.png';
import exhaustedImg from '../assets/status/Exhausted.png';
import frightenedImg from '../assets/status/Frightened.png';
import grappledImg from '../assets/status/Grappled.png';
import incapacitatedImg from '../assets/status/Incapacitated.png';
import invisibleImg from '../assets/status/Invisible.png';
import paralyzedImg from '../assets/status/Paralyzed.png';
import petrifiedImg from '../assets/status/Petrified.png';
import poisonedImg from '../assets/status/Poisoned.png';
import proneImg from '../assets/status/Prone.png';
import restrainedImg from '../assets/status/Restrained.png';
import stunnedImg from '../assets/status/Stunned.png';
import deathImg from '../assets/status/Death.png';

export const GRID_SIZE = 52; // Determines the size of the grid cells 
export const SIDE_GRID_SIZE = 2; // Determines the size of the side grid

// Grid interaction modes
export const MODE = {
  CURSOR: 'CURSOR',
  PAINT: 'PAINT',
  TOKEN: 'TOKEN',
};

// Cursor submodes
export const CURSOR_MODE = {
  GAME: 'GAME',  // Select and move coins
  MAP: 'MAP',    // Select and move objects
};

export const STATUS_ICONS = {
  'Bleeding Out': bleedingOutImg,
  'Blinded': blindedImg,
  'Charmed': charmedImg,
  'Concentration': concentrationImg,
  'Deafened': deafenedImg,
  'Death': deathImg,
  'Exhausted': exhaustedImg,
  'Frightened': frightenedImg,
  'Grappled': grappledImg,
  'Incapacitated': incapacitatedImg,
  'Invisible': invisibleImg,
  'Paralyzed': paralyzedImg,
  'Petrified': petrifiedImg,
  'Poisoned': poisonedImg,
  'Prone': proneImg,
  'Restrained': restrainedImg,
  'Stunned': stunnedImg,
};

export const FANTASY_COLORS = [
  { color: '#C0C0C0', name: 'Silver' },
  { color: '#8B0000', name: 'Dragon Red' },
  { color: '#4B0082', name: 'Mystic Purple' },
  { color: '#006400', name: 'Forest Green' },
  { color: '#00008B', name: 'Royal Blue' },
  { color: '#8B4513', name: 'Leather Brown' },
  { color: '#DAA520', name: 'Golden' },
  { color: '#483D8B', name: 'Twilight' },
  { color: '#2F4F4F', name: 'Stone Grey' },
  { color: '#800080', name: 'Arcane Purple' },
  { color: '#FF4500', name: 'Flame Orange' },
  { color: '#000000', name: 'Shadow Black' },
];

export const PAINT_CURSOR = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath d='M22 2L30 10L15 25L7 17L22 2Z' fill='%23663300' stroke='black'/%3E%3Cpath d='M15 25L7 17L4 28L15 25Z' fill='%23996633' stroke='black'/%3E%3C/svg%3E") 4 28, crosshair`;

export const GRAB_CURSOR = 'grab';
export const GRABBING_CURSOR = 'grabbing';

export const GRID_STYLE = {
  stroke: 'rgba(44, 62, 80, 0.3)',
  strokeWidth: 1,
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  shadowBlur: 2,
  shadowOffset: { x: 0, y: 1 },
};

/** Paint-mode CSS cursors (circle overlay; distinct from PAINT_CURSOR brush in toolbar) */
export const GRID_PAINT_CURSOR = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" fill="rgba(255,255,255,0.5)" stroke="black" stroke-width="2"/></svg>') 12 12, crosshair`;
export const GRID_ERASE_CURSOR = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" fill="rgba(250, 53, 53, 0.5)" stroke="black" stroke-width="2"/></svg>') 12 12, crosshair`;

/**
 * Layout, viewport, Pixi, fog, tokens, and paint-preview tuning for GameGrid.js
 */
export const GAME_GRID = {
  BATTLEMAP_NONE: 'none',

  CANVAS_FALLBACK_WIDTH_OFFSET: 80,
  CANVAS_FALLBACK_HEIGHT_OFFSET: 74,

  PIXI_BACKGROUND_ALPHA: 0,
  PIXI_RESOLUTION_MULTIPLIER: 2,

  VIEWPORT_WORLD_GRID_MULTIPLIER: 2,
  VIEWPORT_PINCH_PERCENT: 1.0,
  VIEWPORT_PINCH_FACTOR: 1.0,
  VIEWPORT_WHEEL_PERCENT: 0.1,
  VIEWPORT_WHEEL_SMOOTH: 5,
  VIEWPORT_WHEEL_LINE_HEIGHT: 20,
  VIEWPORT_DECELERATE_FRICTION: 0.88,
  VIEWPORT_MIN_SCALE: 0.25,
  VIEWPORT_MAX_SCALE: 2,
  VIEWPORT_DEFAULT_ZOOM: 1,

  TRACKPAD_HORIZONTAL_DELTA_THRESHOLD: 0.5,
  TRACKPAD_SMALL_DELTA_PIXEL_THRESHOLD: 50,
  ZOOM_UPDATE_THROTTLE_MS: 50,
  VIEWPORT_ARROW_PAN_SPEED: 50,

  POINTER_BUTTON_PRIMARY: 0,
  POINTER_BUTTON_SECONDARY: 2,

  BATTLEMAP_SPRITE_ALPHA: 0.6,

  FOG_FILL_COLOR: 0x0a0e12,
  FOG_CREATOR_ALPHA: 0.5,
  FOG_PLAYER_ALPHA: 1,
  FOG_LINE_COLOR: 0x2a3540,
  FOG_LINE_STROKE_WIDTH: 2,
  FOG_LINE_ALPHA: 0.8,

  GRID_LINES_STROKE_WIDTH: 1,
  GRID_LINES_COLOR: 0x2c3e50,
  GRID_LINES_ALPHA: 0.6,

  WALL_STROKE_WIDTH: 4,
  WALL_STROKE_COLOR: 0x000000,
  WALL_STROKE_ALPHA: 0.95,
  DOOR_HEIGHT_GRID_FRACTION: 0.35,

  COLOR_ACCENT_GOLD: 0xDAA520,
  COLOR_WALL_ERASE: 0xff7043,
  COLOR_WALL_ERASE_LIGHT: 0xff8a65,
  COLOR_WALL_CORNER_GOLD_LIGHT: 0xF2C14E,
  COLOR_DEFAULT_SILVER: 0xC0C0C0,
  DEFAULT_TOKEN_COLOR_HEX_STRING: '#C0C0C0',
  COLOR_ENEMY_GLOW: 0xff0000,
  COLOR_HEALTH_HIGH: 0x4CAF50,
  COLOR_HEALTH_MID: 0xFFC107,
  COLOR_HEALTH_LOW: 0xF44336,
  COLOR_CONTEXT_HEALTH: 0xf44336,
  COLOR_CONTEXT_STATUS: 0x9c27b0,
  COLOR_CONTEXT_STATBLOCK: 0x2196f3,
  COLOR_CONTEXT_REMOVE: 0xff9800,
  COLOR_SHIELD_FILL: 0x607D8B,
  SHIELD_FILL_ALPHA: 0.9,
  COLOR_SHIELD_STROKE: 0x455A64,
  COLOR_BLACK: 0x000000,
  COLOR_WHITE: 0xffffff,

  HIT_AREA_ALPHA: 0.001,

  AREA_PREVIEW_FILL_ALPHA: 0.2,
  AREA_PREVIEW_STROKE_WIDTH: 3,

  OBJECT_HIGHLIGHT_CORNER_RADIUS: 4,
  OBJECT_HIGHLIGHT_STROKE_WIDTH: 3,
  OBJECT_HIGHLIGHT_STROKE_ALPHA: 0.8,
  OBJECT_HIGHLIGHT_FILL_ALPHA: 0.1,

  WALL_PREVIEW_STROKE_WIDTH: 3,
  WALL_PREVIEW_STROKE_ALPHA: 0.95,
  WALL_CORNER_INNER_RADIUS: 6,
  WALL_CORNER_OUTER_RADIUS: 7,
  WALL_CORNER_STROKE_WIDTH: 2,
  WALL_CORNER_STROKE_ALPHA: 0.6,

  LARGE_TOKEN_GRID_CELLS: 2,
  TOKEN_RADIUS_INSET: 4,
  TOKEN_SHADOW_OFFSET_X: 2,
  TOKEN_SHADOW_OFFSET_Y: 4,
  TOKEN_SHADOW_ALPHA: 0.3,
  TOKEN_SELECTION_OUTSET: 2,
  TOKEN_SELECTION_SIZE_PAD: 4,
  TOKEN_SELECTION_CORNER_RADIUS: 4,
  TOKEN_SELECTION_STROKE_WIDTH: 2,
  TOKEN_SELECTION_STROKE_ALPHA: 0.6,
  TOKEN_CIRCLE_STROKE_WIDTH: 2,
  TOKEN_BORDER_DARKEN_AMOUNT: 0.3,
  TOKEN_HIDDEN_ALPHA: 0.35,
  TOKEN_DEAD_ALPHA: 0.5,
  TOKEN_PAINT_MODE_ALPHA: 0.5,
  TOKEN_DRAG_ALPHA: 0.8,
  OBJECT_DRAG_ALPHA: 0.7,
  OBJECT_PAINT_MODE_ALPHA: 0.5,

  GLOW_DISTANCE: 25,
  GLOW_OUTER_STRENGTH: 0.5,
  GLOW_INNER_STRENGTH: 0.4,
  GLOW_QUALITY: 0.3,

  TOKEN_SPRITE_RADIUS_SCALE: 1.8,
  TOKEN_MASK_RADIUS_INSET: 2,

  NAME_MAX_CHARS_LARGE: 28,
  NAME_MAX_CHARS_SMALL: 20,
  NAME_FONT_SIZE_LARGE: 15,
  NAME_FONT_SIZE_SMALL: 12,
  NAME_TEXT_RESOLUTION: 2,
  NAME_LABEL_OFFSET_Y: 4,
  NAME_PADDING: 4,
  NAME_BG_OFFSET_Y: 2,
  NAME_BG_CORNER_RADIUS: 4,
  NAME_BG_ALPHA: 0.6,

  HEALTH_BAR_WIDTH_MULT_LARGE: 1.8,
  HEALTH_BAR_WIDTH_MULT_SMALL: 1.3,
  HEALTH_BAR_HEIGHT: 12,
  HEALTH_BAR_GAP: 4,
  HEALTH_BAR_CORNER_RADIUS: 2,
  HEALTH_BG_ALPHA: 0.5,
  HEALTH_FILL_ALPHA: 0.5,
  HEALTH_THRESHOLD_HIGH: 0.5,
  HEALTH_THRESHOLD_LOW: 0.25,
  HEALTH_TEXT_FONT_WEIGHT: 200,
  HEALTH_TEXT_FONT_SIZE: 12,
  HEALTH_TEXT_RESOLUTION: 2,

  SHIELD_SIZE_LARGE: 24,
  SHIELD_SIZE_SMALL: 18,
  SHIELD_OFFSET_X: 2,
  AC_FONT_SIZE_LARGE: 12,
  AC_FONT_SIZE_SMALL: 10,
  AC_TEXT_RESOLUTION: 2,
  AC_SHIELD_STROKE_WIDTH: 1.5,

  STATUS_ICON_SIZE_LARGE: 18,
  STATUS_ICON_SIZE_SMALL: 14,
  STATUS_ICON_SPACING: 2,
  STATUS_BASE_OFFSET: 4,
  STATUS_BG_CORNER_RADIUS: 3,
  STATUS_BG_ALPHA: 0.7,

  CONTEXT_ACTION_ICON_SIZE: 24,
  CONTEXT_ACTION_ICON_SPACING: 4,
  CONTEXT_ACTION_START_OFFSET_X: 28,
  CONTEXT_ACTION_SPRITE_SCALE: 0.55,
  CONTEXT_ACTION_CIRCLE_ALPHA: 0.95,
  CONTEXT_ICON_HOVER_SCALE: 1.1,
  CONTEXT_ICON_NORMAL_SCALE: 1,

  Z_INDEX_SELECTED: 1,
  Z_INDEX_NORMAL: 0,
};